import axios from "axios";
import authHeader from "@/services/auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/nwapp/mstcode`;

class MstCodeService {
  get(codeType) {
    return axios
      .get(`${API_URL}/${codeType}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }
}

export default new MstCodeService();
